import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";

const actions = {
  getPredefinedLotNumbers({ commit }, payload) {
    return api.fetchFull(endpoints.SM_PREDEFINED_LOT_NUMBERS, payload, commit, (response) => {
      return response;
    });
  },

  getPredefinedLotNumberByUuid({ commit }, payload) {
    return api.fetchFull(endpoints.SM_PREDEFINED_LOT_NUMBERS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  createPredefinedLotNumber({ commit }, payload) {
    return api.post(endpoints.SM_PREDEFINED_LOT_NUMBERS, payload, commit, (response) => {
      return response;
    });
  },

  updatePredefinedLotNumber({ commit }, payload) {
    return api.put(endpoints.SM_PREDEFINED_LOT_NUMBERS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  deletePredefinedLotNumber({ commit }, payload) {
    return api.remove(endpoints.SM_PREDEFINED_LOT_NUMBERS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },
};

export default actions;
